import { ActiveAccountCard } from "@/components/account-center/TopBarAccountCluster";
import { GlobalClock } from "@/components/GlobalClock";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";
import { useUserRole } from "@/hooks/useUserRole";

interface TopBarProps {
  isRTL: boolean;
}

export const TopBar = ({ isRTL }: TopBarProps) => {
  const { role } = useUserRole();
  const isIB = role === "ib";

  return (
    <header
      className="hidden lg:flex fixed top-0 left-0 right-0 z-50 h-16 items-center justify-between border-b bg-card/95 backdrop-blur-sm px-6 shadow-sm"
    >
      <div className="flex items-center gap-3">
        <span className="text-3xl font-bold tracking-tight text-foreground">Jourex.Trade</span>
        <span className="text-xs text-muted-foreground hidden xl:inline">Journal Trading & Forex Assistant</span>
      </div>
      <div className="flex items-center gap-3">
        {!isIB && <ActiveAccountCard />}
        <LanguageSwitcher />
        <GlobalClock />
      </div>
    </header>
  );
};
